var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-global-footer-nav l-grid__item" },
    [
      _vm.nav.title
        ? _c("h4", { staticClass: "t-heading-6 u-margin-bottom-small" }, [
            _vm._v("\n    " + _vm._s(_vm.nav.title) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.nav.navItems.length > 0
        ? _c(
            "ul",
            { staticClass: "c-global-footer-nav__list u-margin-bottom-small" },
            [
              _vm._l(_vm.nav.navItems, function(item, itemIndex) {
                return [
                  item.linkText
                    ? _c(
                        "li",
                        {
                          key: itemIndex,
                          staticClass: "c-global-footer-nav__item t-paragraph"
                        },
                        [
                          _vm.isRemoteUrl(item.linkUrl) || item.externalLink
                            ? _c(
                                "a",
                                {
                                  staticClass: "t-link t-link--nav",
                                  attrs: { href: item.linkUrl }
                                },
                                [_vm._v(_vm._s(item.linkText))]
                              )
                            : _c(
                                "nuxt-link",
                                {
                                  staticClass: "t-link t-link--nav",
                                  attrs: { to: item.linkUrl }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(item.linkText) +
                                      "\n        "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }